module.exports = __webpack_public_path__ + "img/13.0cdd798c.png";